import { MenuItem } from "../../../../_metronic/layout/components/header/header-menus/MenuItem"
import { useAuth } from "../../auth"
import { useAppView } from "../../core/app/AppViewContext"
import { MenuInnerWithSub } from "../../../../_metronic/layout/components/header/header-menus/MenuInnerWithSub"
import { UserPagesMenu } from "./UserPagesMenu"

const UserMenuInner = () => {

    const {currentUser, hasRole} = useAuth();
    const { cntApplications, cntDLMSiteInspectApplications, cntDLMDOCApplications, cntDLMLabelApplications } = useAppView();

    if (! currentUser) return null;
    
    return(
    <>

    <MenuInnerWithSub
        isMega={true}
        title='Directory'
        to='/directory'
        menuPlacement='bottom-start'
        menuTrigger='click'        
        >
        <UserPagesMenu />
    </MenuInnerWithSub>

    
    { (currentUser.role !== 'System Admin' && cntApplications > 0) && 
        <MenuItem title="COC Applications" to='/setsco/application-management' showCount={cntApplications} />
    }
    
    { ((currentUser.role !== 'System Admin') && hasRole(['System Admin','DLM Admin',"DLM Program Manager", "DLM Inspector"])) && 
    <>
    { (cntDLMSiteInspectApplications > 0) && 
        <MenuItem title="Site Inspections" to='/setsco/doclabel-management/siteinspection-applications-list' showCount={cntDLMSiteInspectApplications} />
    }
    { (cntDLMDOCApplications > 0) && 
        <MenuItem title="DOC Applications" to='/setsco/doclabel-management/doc-applications-list' showCount={cntDLMDOCApplications} />
    }
    { (cntDLMLabelApplications > 0) && 
        <MenuItem title="Label Applications" to='/setsco/doclabel-management/label-applications-list' showCount={cntDLMLabelApplications} />
    }
    </>
    }    
    </>
    )
}

export {UserMenuInner}